'use client'

import React, { useCallback, useEffect, useState } from 'react'
import Image from 'next/image'
import useEmblaCarousel from 'embla-carousel-react'
import { EmblaCarouselType } from 'embla-carousel'
import { useThrottledCallback } from 'use-debounce'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface Stage {
	number: string
	title: string
	description: string
}

// ЗАГЛУШКИ: контент и пути к картинкам карточек — заменить на свои
const stages: Stage[] = [
	{
		number: '01',
		title: 'Быстрые переводы',
		description: 'Все межбанковские проверки уже зашиты в систему. Платёж между юрлицами проходит без ручных проверок и задержек — так же быстро, как перевод между физлицами.'
	},
	{
		number: '02',
		title: 'Единый ЛК',
		description: 'Вы заходите в личный кабинет, формируете счёт и отправляете клиенту ссылку или QR-код. Контрагенту не нужно ничего дополнительно устанавливать или заполнять.'
	},
	{
		number: '03',
		title: 'Оплата кредитом',
		description: 'Если у вашего покупателя нет свободных денег на счёте, он может оплатить покупку в кредит. Одобрение банка занимает 3 минуты, так как его скоринг пройден внутри системы.'
	}
]

// ЗАГЛУШКИ: пути к картинкам карточек — заменить на свои
const imagePaths = [
	'/images/b2b/advantages_1.svg',
	'/images/b2b/advantages_2.svg',
	'/images/b2b/advantages_3.svg'
]

const Advantages: React.FC = () => {
	const [emblaRef, emblaApi] = useEmblaCarousel({
		dragFree: true,
		align: 'start',
		breakpoints: { '(min-width: 1440px)': { active: false } }
	})

	const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
	const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

	const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
		setPrevBtnDisabled(!emblaApi.canScrollPrev())
		setNextBtnDisabled(!emblaApi.canScrollNext())
	}, [])

	const onSelectThrottled = useThrottledCallback(onSelect, 100)

	useEffect(() => {
		if (!emblaApi) return

		onSelect(emblaApi)
		emblaApi.on('reInit', onSelect).on('select', onSelect)
	}, [emblaApi, onSelect, onSelectThrottled])

	const onPrevButtonClick = useCallback(() => {
		if (!emblaApi) return
		emblaApi.scrollPrev()
	}, [emblaApi])

	const onNextButtonClick = useCallback(() => {
		if (!emblaApi) return
		emblaApi.scrollNext()
	}, [emblaApi])

	return (
		<section className={styles.advantages}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.subtitle}>Преимущества</div>
				<h2
					className={styles.title}
					dangerouslySetInnerHTML={{ __html: '<span>Мгновенные расчёты</span><br>без проверок и ожидания' }}
				/>
			</AnimatedSection>

			<AnimatedSection animation='slideUp'>
				<div className={styles.stagesSlider}>
					<div className={styles.stagesSliderContainer}>
						<div className={styles.embla}>
							<div className={styles.embla__viewport} ref={emblaRef}>
								<div className={styles.embla__container}>
									{stages.map((stage, index) => (
										<div key={index} className={styles.embla__slide}>
											<div className={styles.stageCard}>
												<div className={styles.stageNumber}>
													{stage.number}
												</div>
												<div className={styles.stageImage}>
													<Image
														src={imagePaths[index]}
														alt={stage.title}
														width={310}
														height={200}
														className={styles.image}
													/>
												</div>
												<h3 className={styles.stageTitle} dangerouslySetInnerHTML={{ __html: stage.title }}></h3>
												<p className={styles.stageDescription}>{stage.description}</p>
											</div>
										</div>
									))}
								</div>
							</div>

							{!prevBtnDisabled && (
								<button
									className={styles.embla__prev}
									onClick={onPrevButtonClick}
								>
									<Image
										src="/images/portfolio/lk-agro-b2b/slider-button-left.svg"
										alt="Previous"
										width={34}
										height={34}
									/>
								</button>
							)}

							{!nextBtnDisabled && (
								<button
									className={styles.embla__next}
									onClick={onNextButtonClick}
								>
									<Image
										src="/images/portfolio/lk-agro-b2b/slider-button-right.svg"
										alt="Next"
										width={34}
										height={34}
									/>
								</button>
							)}
						</div>
					</div>
				</div>
			</AnimatedSection>
		</section>
	)
}

Advantages.displayName = 'Advantages'

export default Advantages
